var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "var(--icon-fill)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2640_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    fill: "var(--icon-fill)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2640_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 26.75V4.25H15V6.75H6.25V24.25H15V26.75H3.75ZM20 21.75L18.2812 19.9375L21.4688 16.75H11.25V14.25H21.4688L18.2812 11.0625L20 9.25L26.25 15.5L20 21.75Z",
    fill: "var(--icon-fill)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0ca2651a90de044bb4372b192d0b3f51.svg";
export { ForwardRef as ReactComponent };